import { useQuery } from '@tanstack/react-query';
import { inquiriesApi } from '@/lib/api/inquiries';

export function useInquiry(id: string | undefined) {
  return useQuery({
    queryKey: ['inquiry', id],
    queryFn: () => inquiriesApi.getInquiry(id!),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}

export function useInquiries(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['inquiries'],
    queryFn: () => inquiriesApi.getInquiries(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    enabled: options?.enabled ?? true,
  });
}
